import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-114">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-white mb-1.5 ml-1 drop-shadow-sm" data-id="element-115">
          {label}
        </label>}
      <input id={inputId} className={`
          w-full px-5 py-4 rounded-xl bg-white/90 backdrop-blur-sm border-2 
          text-gray-900 placeholder:text-gray-400 font-medium
          focus:outline-none focus:ring-4 focus:ring-white/30 focus:border-white
          transition-all duration-200
          ${error ? 'border-red-400 focus:ring-red-200' : 'border-transparent'}
          ${className}
        `} {...props} data-id="element-116" />
      {error && <p className="mt-1.5 text-sm text-red-100 font-medium ml-1 bg-red-500/20 px-2 py-0.5 rounded inline-block" data-id="element-117">
          {error}
        </p>}
    </div>;
}